import http from '@/communication/AuthConnection'

export default async ({ commit }, payload) => {
  try {
    const request = await http.get(`/v1/board/chat/${payload.eventId}`, {
      params: payload
    })
    return request.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/brain/board/chat-list-messages/index.js